module.exports = __webpack_public_path__ + "img/vehicle-options-black-kia.32997dc1.png";